// Autogenerated file
import sidebarMenu from './sidebarMenu';

export default {
  ...sidebarMenu,
};
